import React from 'react';
import { Modal } from 'antd';
import classes from './ConfirmationModal.module.scss';
import { useTranslation } from 'react-i18next';
import UploadingComponent from 'components/UploadingComponent/UploadingComponent';
import cn from 'classnames';
import { getTheme } from 'helpers/getTheme';

type ConfirmationModalPops = {
  isOpen: boolean;
  onCancel: () => void;
  isLoading: boolean;
  submit: () => void;
  text: string | JSX.Element | JSX.Element[];
  title: string | JSX.Element;
  okText?: string;
  cancelText?: string;
  customClassname?: string
  okDisable?: boolean;
  centered?: boolean;
  okBtnDanger?: boolean;
};

const ConfirmationModal = ({
  isOpen,
  onCancel,
  isLoading,
  submit,
  text,
  title,
  okText,
  cancelText,
  customClassname,
  okDisable,
  centered,
  okBtnDanger
}: ConfirmationModalPops) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={isOpen}
      width={420}
      onCancel={onCancel}
      okText={okText || t('Documents.management.delete')}
      cancelText={cancelText || t('Documents.management.cancel')}
      confirmLoading={isLoading}
      cancelButtonProps={{ style: cancelText ? {} : {display: 'none'}  }}
      okButtonProps={{
        style: cancelText ? {} : {width: '100%', margin: 0},
        disabled: okDisable,
        danger: okBtnDanger || false,
      }}
      centered={centered}
      closeIcon={customClassname === 'logout' ? false : true}
      title={title}
      onOk={submit}
      className={cn(
        classes.modalDelete,
        customClassname === 'logout' ? classes.titleFlexStart : 'null',
        getTheme()
      )}
    >
      <div className={customClassname ? classes[customClassname] : classes.delete}>
        {text}
      </div>

      {isLoading && <UploadingComponent />}
    </Modal>
  );
};

export default ConfirmationModal;
